/**
=========================================================
* MOTYB Course Content
* Month Of The Year Backwards course content
=========================================================
*/

// Course components
import VideoQuestion from "./components/VideoQuestion";

// Export course configuration
export const courseConfig = {
  title: "MOTYB",
  subtitle: "Month Of The Year Backwards",
  totalSteps: 3,
};

// Export function to get question component for a step
export function getQuestionComponent(step) {
  const questions = [
    {
      question: "What MOTYB level is Doris on?",
      videoSrc: require("./videos/motyb_1.webm"),
      options: [
        {
          value: "motyb0",
          label: "MOTYB 0 = Patient achieves 7 or more months of correct answering",
        },
        {
          value: "motyb1",
          label: "MOTYB 1 = Patient starts but only responds correctly on <7 / refuses to start",
        },
        {
          value: "motyb2",
          label: "MOTYB 2 = Patient unable to test / cannot start",
        },
      ],
    },
    {
      question: "What MOTYB level is Doris on?",
      videoSrc: require("./videos/motyb_2.webm"),
      options: [
        {
          value: "motyb0",
          label: "MOTYB 0 = Patient achieves 7 or more months of correct answering",
        },
        {
          value: "motyb1",
          label: "MOTYB 1 = Patient starts but only responds correctly on <7 / refuses to start",
        },
        {
          value: "motyb2",
          label: "MOTYB 2 = Patient unable to test / cannot start",
        },
      ],
    },
    {
      question: "What MOTYB level is Doris on?",
      videoSrc: require("./videos/motyb_3.webm"),
      options: [
        {
          value: "motyb0",
          label: "MOTYB 0 = Patient achieves 7 or more months of correct answering",
        },
        {
          value: "motyb1",
          label: "MOTYB 1 = Patient starts but only responds correctly on <7 / refuses to start",
        },
        {
          value: "motyb2",
          label: "MOTYB 2 = Patient unable to test / cannot start",
        },
      ],
    },
  ];

  const questionData = questions[step - 1];
  if (!questionData) return null;

  // Use key prop to force React to unmount/remount component when step changes
  return (
    <VideoQuestion
      key={`motyb-question-${step}`}
      question={questionData.question}
      videoSrc={questionData.videoSrc}
      options={questionData.options}
    />
  );
}
